import type { Customer } from "@/mocks/admin/customers";

type Props = {
  customer: Customer;
};

export default function ContactPanel({ customer }: Props) {
  return (
    <div className="bg-white border border-ink-100 rounded-lg">
      <div className="px-5 py-3 border-b border-ink-100">
        <h3 className="font-display text-sm font-bold text-ink-900">Contact</h3>
      </div>

      <dl className="divide-y divide-ink-100">
        <Row label="Phone">
          <a
            href={`tel:${customer.phone}`}
            className="text-sm text-ink-900 hover:text-brand-700 cursor-pointer font-mono"
          >
            {customer.phone}
          </a>
        </Row>
        <Row label="Email">
          <a
            href={`mailto:${customer.email}`}
            className="text-sm text-ink-900 hover:text-brand-700 cursor-pointer truncate block"
          >
            {customer.email}
          </a>
        </Row>
        <Row label="Location">
          <span className="text-sm text-ink-900">
            {customer.city}, {customer.state}
          </span>
        </Row>
        <Row label="Source">
          <span className="text-sm text-ink-900">{customer.source}</span>
        </Row>
      </dl>

      {customer.tags.length > 0 && (
        <div className="px-5 py-4 border-t border-ink-100">
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-bold mb-2">
            Tags
          </div>
          <div className="flex flex-wrap gap-1.5">
            {customer.tags.map((t) => (
              <span
                key={t}
                className="text-[11px] font-semibold px-2 py-0.5 rounded bg-cream-100 text-ink-700"
              >
                {t}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="px-5 py-3 flex items-center justify-between gap-3">
      <dt className="text-[11px] uppercase tracking-wider text-ink-400 font-bold shrink-0">
        {label}
      </dt>
      <dd className="text-right min-w-0 max-w-[60%]">{children}</dd>
    </div>
  );
}